import React from "react";
import PropTypes from "prop-types";
import Warning from "MODULES/shared/components/Warning/Warning";
import {
  CITY,
  COUNTRY,
  LINE1,
  PHONE,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";
import { BILLING_ADDRESS } from "MODULES/companies/constants";

export default function MissingFieldsWarning({
  company,
  contact,
  getFieldValue
}) {
  if (!company || !company.id) return null;

  const missing = [];

  const phoneValue = getFieldValue(PHONE) || company.phone;
  if (!phoneValue) {
    missing.push("phone number");
  }

  const contactName =
    (contact && contact.name) || getFieldValue("contact.name");
  if (!contactName) {
    missing.push("contact name");
  }

  const contactEmail =
    (contact && contact.email) || getFieldValue("contact.email");
  if (!contactEmail) {
    missing.push("contact email");
  }

  const line1 =
    getFieldValue(`${BILLING_ADDRESS}.${LINE1}`) ||
    (company.billing_address && company.billing_address.line1);
  const city =
    getFieldValue(`${BILLING_ADDRESS}.${CITY}`) ||
    (company.billing_address && company.billing_address.city);
  const state =
    getFieldValue(`${BILLING_ADDRESS}.${STATE}`) ||
    (company.billing_address && company.billing_address.state);
  const postalCode =
    getFieldValue(`${BILLING_ADDRESS}.${POSTAL_CODE}`) ||
    (company.billing_address && company.billing_address.postal_code);
  const country =
    getFieldValue(`${BILLING_ADDRESS}.${COUNTRY}`) ||
    (company.billing_address && company.billing_address.country);

  if (!line1 || !city || !state || !postalCode || !country) {
    missing.push("complete billing address");
  }

  // If nothing is missing, do not display a warning
  if (!missing.length) {
    return null;
  }

  return (
    <Warning>
      Customer is missing the following required field(s): {missing.join(", ")}.
    </Warning>
  );
}

MissingFieldsWarning.propTypes = {
  company: PropTypes.instanceOf(Object),
  contact: PropTypes.instanceOf(Object),
  getFieldValue: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/MissingFieldsWarning.jsx